/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Effectivedate2Inputs */

const id_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Efektif`)
};

const ms_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Berkuat Kuasa`)
};

const da_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikrafttrædelsesdato`)
};

const de_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirksamkeitsdatum`)
};

const en_us2_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effective Date`)
};

const es_es2_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha efectiva`)
};

const es_mx2_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha efectiva`)
};

const fil_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epektibong Petsa`)
};

const fr_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'effet`)
};

const it_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data effettiva`)
};

const hu_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatályos dátum`)
};

const nl_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingangsdatum`)
};

const no_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikrafttredelsesdato`)
};

const pl_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data wejścia w życie`)
};

const pt_br2_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Efetiva`)
};

const pt_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de vigência`)
};

const ro_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data efectivă`)
};

const fi_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voimaantulopäivä`)
};

const sv_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikraftträdandedatum`)
};

const vi_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hiệu lực`)
};

const tr_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yürürlük Tarihi`)
};

const cs_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum účinnosti`)
};

const bg_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на влизане в сила`)
};

const ru_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата вступления в силу`)
};

const uk_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата набрання чинності`)
};

const ar_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ السريان`)
};

const hi_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रभावी तारीख़`)
};

const th_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่มีผล`)
};

const ja_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発効日`)
};

const zh_cn2_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效日期`)
};

const zh_hant1_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效日期`)
};

const ko_tags_sortby_effectivedate2 = /** @type {(inputs: Tags_Sortby_Effectivedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적용일`)
};

/**
* | output |
* | --- |
* | "Effective Date" |
*
* @param {Tags_Sortby_Effectivedate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_effectivedate2 = /** @type {((inputs?: Tags_Sortby_Effectivedate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Effectivedate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_effectivedate2(inputs)
	if (locale === "ms") return ms_tags_sortby_effectivedate2(inputs)
	if (locale === "da") return da_tags_sortby_effectivedate2(inputs)
	if (locale === "de") return de_tags_sortby_effectivedate2(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_effectivedate2(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_effectivedate2(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_effectivedate2(inputs)
	if (locale === "fil") return fil_tags_sortby_effectivedate2(inputs)
	if (locale === "fr") return fr_tags_sortby_effectivedate2(inputs)
	if (locale === "it") return it_tags_sortby_effectivedate2(inputs)
	if (locale === "hu") return hu_tags_sortby_effectivedate2(inputs)
	if (locale === "nl") return nl_tags_sortby_effectivedate2(inputs)
	if (locale === "no") return no_tags_sortby_effectivedate2(inputs)
	if (locale === "pl") return pl_tags_sortby_effectivedate2(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_effectivedate2(inputs)
	if (locale === "pt") return pt_tags_sortby_effectivedate2(inputs)
	if (locale === "ro") return ro_tags_sortby_effectivedate2(inputs)
	if (locale === "fi") return fi_tags_sortby_effectivedate2(inputs)
	if (locale === "sv") return sv_tags_sortby_effectivedate2(inputs)
	if (locale === "vi") return vi_tags_sortby_effectivedate2(inputs)
	if (locale === "tr") return tr_tags_sortby_effectivedate2(inputs)
	if (locale === "cs") return cs_tags_sortby_effectivedate2(inputs)
	if (locale === "bg") return bg_tags_sortby_effectivedate2(inputs)
	if (locale === "ru") return ru_tags_sortby_effectivedate2(inputs)
	if (locale === "uk") return uk_tags_sortby_effectivedate2(inputs)
	if (locale === "ar") return ar_tags_sortby_effectivedate2(inputs)
	if (locale === "hi") return hi_tags_sortby_effectivedate2(inputs)
	if (locale === "th") return th_tags_sortby_effectivedate2(inputs)
	if (locale === "ja") return ja_tags_sortby_effectivedate2(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_effectivedate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_effectivedate2(inputs)
	return ko_tags_sortby_effectivedate2(inputs)
});
export { tags_sortby_effectivedate2 as "tags.sortBy.effectiveDate" }